<div *ngIf="regionalisationEnabled">
  <p-dropdown
    id="language-dropdown"
    [options]="languages"
    [(ngModel)]="selectedLanguage.value"
    (onChange)="onLanguageSelected($event)"
    [autoWidth]="false"
    [autoDisplayFirst]="false"
    appendTo="body"
    [style]="{ minWidth: '130px', width: '230px' }"
  >
    <ng-template let-item pTemplate="item">
      <span class="language-item-text">{{ item.label }}</span>
    </ng-template>

    <ng-template let-language pTemplate="selectedItem">
      <span class="language-item-text">{{ selectedLanguage.label }}</span>
    </ng-template>
  </p-dropdown>
</div>
